module.exports = __webpack_public_path__ + "img/Naver_Pay_KR.77abec84.png";